<template>

  <div
  v-bind:style="{
    'font-size': infoFontSize
  }"
  ontouchstart=""
  class="comp-verification-event-snapshot" v-on:click="toggleTimebar">

    <div class="info-container timebar" v-bind:class="{'interactive-timebar' : isShowTimebar,}" v-on:click="toggleTimebar(true)">
    
      <!-- <div class="info-items scrollable -x scrollbar-hidden">
        <div class="info-item black">EVENT VIDEO</div>
        <div
        v-if="eventLocaleTimeString"
        class="info-item black">{{eventLocaleTimeString}}{{friendlyEventTimeString ? ' (' + friendlyEventTimeString + ' ago)' : ''}}</div>
      </div> -->

      <div
      v-if="statusGetVerificationEventMedias"
      v-bind:class="{
        ready: statusGetVerificationEventMedias === 'successful',
        warning: statusGetVerificationEventMedias === 'requested',
        error: statusGetVerificationEventMedias === 'failed'
      }"
      class="status-container">
        <comp-play-slider
        v-on:onClickFrameIndex="onClickFrameIndex"
        v-on:onClickPlay="onClickPlay"
        v-on:onClickSlider="toggleTimebar(true)"
        v-bind:isPaused="!isPlaying"
        v-bind:frameRate="2"
        v-bind:isControllable="isControllable"
        v-bind:totalFrame="totalSnapshots"
        v-bind:totalAvailableFrame="totalSnapshots"
        v-bind:currentFrame="selectedEventSnapshotIndex + 1"
        ></comp-play-slider>
      </div>
    </div>

    <!-- show snapshot always -->
    <comp-snapshot
    v-bind:snapshot="snapshotUrl"></comp-snapshot>
  
    <template v-if="statusGetVerificationEventMedias">
      <template v-if="statusGetVerificationEventMedias === 'successful' || statusGetVerificationEventMedias === 'failed'">
        <template v-if="totalSnapshotToDownload === 0">
          <div class="no-snapshot-text-wrapper">
            <div class="no-snapshot-text">No snapshots available</div>
          </div>
        </template>
      </template>
    </template>

  </div>

</template>

<script>
import CompIcon from '@/components/CompIcon'
import CompSnapshot from '@/components/CompSnapshot'
import CompPlaySlider from '@/components/CompPlaySlider'
export default {
  name: 'comp-verification-event-snapshot',
  components: {
    CompIcon,
    CompSnapshot,
    CompPlaySlider
  },
  props: {
    infoFontSize: {
      type: String,
      default: function () {
        return '16px'
      }
    },
    autoPlay: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    isControllable: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    verificationRequesteeSite: function () {
      return this.$store.getters.verificationRequesteeSite
    },
    verificationEvent: function () {
      return this.$store.getters.verificationEvent
    },
    verificationEventMedias: function () {
      return this.$store.getters.verificationEventMedias
    },
    verificationEventRecords: function () {
      return this.$store.getters.verificationEventRecords
    },
    statusGetVerificationEvent: function () {
      return this.$store.getters.statusGetVerificationEvent
    },
    statusGetVerificationEventMedias: function () {
      return this.$store.getters.statusGetVerificationEventMedias
    },
    statusGetVerificationEventRecord: function () {
      return this.$store.getters.statusGetVerificationEventRecord
    }
  },
  data: function () {
    return {
      eventLocaleTimeString: null,
      friendlyEventTimeString: null,
      deviceName: null,
      deviceId: null,
      recordId: null,
      eventZone: null,
      eventType: null,
      eventStatus: null,
      snapshotUrl: null,
      playingEventSnapshot$i: null,
      selectedEventSnapshotIndex: 0,
      totalSnapshots: 0,
      totalSnapshotToDownload: 0,
      totalSnapshotDownloaded: 0,
      isPlaying: true,
      isShowTimebar: true,
      timebarShow$: null
    }
  },
  watch: {
    verificationRequesteeSite: function () {
      this.updateEventRelatedInfo()
    }
  },
  created: function () {
    this.init()
  },
  beforeDestroy: function () {
    this.stopPlayingEventSnapshot()
  },
  mounted: function () {
    this.toggleTimebar(true)
  },
  methods: {
    init: function () {
      this.snapshotUrl = null
      this.selectedEventSnapshotIndex = 0
      this.totalSnapshots = 0
      this.totalSnapshotToDownload = 0
      this.totalSnapshotDownloaded = 0
      this.getVerificationEvent()
      this.updateEventRelatedInfo()
      this.startPlayingEventSnapshot()
      this.isPlaying = true
    },
    getVerificationEvent: function () {
      this.$logger.info('getVerificationEvent')
      this.$store.dispatch('getVerificationEvent')
    },
    updateEventRelatedInfo: function () {
      if (this.verificationEvent instanceof Object) {
        if (this.verificationRequesteeSite.timezone) {
          let timezoneOffset = this.$tool.getUtcOffset((this.verificationRequesteeSite.timezone))
          let eventLocalTimestamp = this.$tool.getLocalTimestamp(this.verificationEvent.eventTimestamp * 1000, timezoneOffset)
          this.eventLocaleTimeString = new Date(eventLocalTimestamp).toLocaleTimeString()
        }
        this.friendlyEventTimeString = this.$tool.getTimeDiffFromNow(+this.verificationEvent.eventTimestamp * 1000).textDetail
        // let deviceId = this.verificationEvent.deviceInfo.deviceId
        // this.deviceId = deviceId
        // if (this.monitoringDevice(deviceId).zoneInfo.alarm) {
        //   this.eventZone = this.monitoringDevice(deviceId).zoneInfo.alarm
        // } else if (this.monitoringDevice(deviceId).zoneInfo.trouble) {
        //   this.eventZone = this.monitoringDevice(deviceId).zoneInfo.trouble
        // } else if (this.monitoringDevice(deviceId).zoneInfo.virtual) {
        //   this.eventZone = this.monitoringDevice(deviceId).zoneInfo.virtual
        // } else {
        //   this.eventZone = this.monitoringSite.virtualZone
        // }
        // this.deviceName = this.monitoringDevice(deviceId).deviceName
        // this.eventType = obj.eventType
        // this.eventStatus = obj.eventStatus
      }
    },
    downloadAllEventSnapshot: function () {
      let secondLimit = 60 * 2 // 2 minutes old event (snapshot is possibly already uploaded, but not updated as completed)

      if (this.verificationEvent && this.verificationEventMedias) {
        let timestamp = this.verificationEvent.eventTimestamp
        let isNewEventRecord = this.$tool.getTimeDiffFromNow(timestamp * 1000).diffInSec < secondLimit
        // [statistics] update totalSnapshotToDownload, totalSnapshotDownloaded
        let totalSnapshotToDownload = 0
        let totalSnapshotDownloaded = 0
        let totalSnapshots = 0
        for (let index = 0; index < this.verificationEventMedias.length; index++) {
          let recordInfo = this.verificationEventMedias[index]
          let recordId = recordInfo.recordId
          if (recordInfo.format !== 'jpg') continue
          totalSnapshots += 1
          if (isNewEventRecord || recordInfo.statusInfo.completed || recordInfo.statusInfo.reallyUploaded === null) {
            totalSnapshotToDownload += 1
          }
          if (this.verificationEventRecords(recordId)) {
            totalSnapshotDownloaded += 1
          }
        }
        // If it is not new record (from brand new event), you should have all snapshots with "completed === false"
        // in that case,,, soon,,, totalSnapshotToDownload goes 0 after secondLimit for isNewEventRecord
        // but snapshot may already updated to the cloud!!!
        // it is to fix the problem
        if (totalSnapshotToDownload === 0 && totalSnapshotDownloaded > 0) {
          totalSnapshotToDownload = totalSnapshotDownloaded
        }
        // [IMPORTANT] it is to control play slider
        this.totalSnapshots = totalSnapshots
        this.totalSnapshotToDownload = totalSnapshotToDownload
        this.totalSnapshotDownloaded = totalSnapshotDownloaded
        // [download] snapshot
        for (let index = 0; index < this.verificationEventMedias.length; index++) {
          let recordInfo = this.verificationEventMedias[index]
          if (recordInfo.format !== 'jpg') continue
          let needToDownloadSnapshot = false

          let recordId = recordInfo.recordId
          let snapshotUrl = recordInfo.url
          if (isNewEventRecord || recordInfo.statusInfo.completed || recordInfo.statusInfo.reallyUploaded === null) {
            // 1. event snapshot is not downloaded
            if (!this.verificationEventRecords(recordId)) {
              // 2. event snapshot download is not requested yet
              if (!this.statusGetVerificationEventRecord(recordId)) {
                needToDownloadSnapshot = true
              } else {
                // 3. event snapshot download is requested, but failed
                if (this.statusGetVerificationEventRecord(recordId) === 'failed') {
                  needToDownloadSnapshot = true
                }
              }
            }
          }
          if (needToDownloadSnapshot) {
            this.downloadEventSnapshot(index, recordId, snapshotUrl)
            // need to make sure download snapshot before request another snapshot
            break
          }
        }
      }
    },
    downloadEventSnapshot: function (snapshotIndex, recordId, snapshotUrl) {
      this.$logger.info('downloadEventSnapshot: requested: recordId({recordId})'
        .replace('{recordId}', recordId))
      this.$store.dispatch('getVerificationEventRecord', {
        snapshotIndex: snapshotIndex,
        recordId: recordId,
        url: snapshotUrl
      })
    },
    startPlayingEventSnapshot: function () {
      let playSpeedInterval = 1000 * 0.2
      this.downloadAllEventSnapshot()
      this.stopPlayingEventSnapshot()
      this.playingEventSnapshot$i = setInterval(() => {
        this.onEachIntervalOfPlayingEventSnapshot()
      }, playSpeedInterval)
      this.toggleTimebar(true)
    },
    onEachIntervalOfPlayingEventSnapshot: function () {
      // 1. Show only if event snapshot is already downloaded
      if (this.verificationEventMedias) {
        this.downloadAllEventSnapshot()
        if (this.isPlaying) {
          let nextAvailableEventSnapshotIndex = this.getNextAvailableEventSnapshotIndex()
          if (this.autoPlay) {
            this.showSnapshot(nextAvailableEventSnapshotIndex)
          } else if (nextAvailableEventSnapshotIndex === 0) {
            this.showSnapshot(nextAvailableEventSnapshotIndex)
          }
        }
        // console.warn(this.isPlaying)
        this.friendlyEventTimeString = this.$tool.getTimeDiffFromNow(+this.verificationEvent.eventTimestamp * 1000).textDetail
      }
    },
    stopPlayingEventSnapshot: function () {
      if (this.playingEventSnapshot$i) {
        clearInterval(this.playingEventSnapshot$i)
        // this.playingEventSnapshot$i = null
      }
    },
    getNextAvailableEventSnapshotIndex: function () {
      let nextAvailableEventSnapshotIndex = 0
      for (let index = (this.selectedEventSnapshotIndex + 1); this.verificationEventMedias.length > index; index++) {
        if (this.verificationEventMedias[index]) {
          let recordId = this.verificationEventMedias[index].recordId
          if (this.verificationEventRecords(recordId) && this.verificationEventMedias[index].format === 'jpg') {
            nextAvailableEventSnapshotIndex = index
            break
          }
        }
      }
      return nextAvailableEventSnapshotIndex
    },
    showSnapshot: function (snapshotIndex) {
      if (this.verificationEventMedias[snapshotIndex]) {
        let recordId = this.verificationEventMedias[snapshotIndex].recordId
        this.recordId = recordId
        this.selectedEventSnapshotIndex = snapshotIndex
        this.snapshotUrl = this.verificationEventRecords(recordId)
      }
    },
    onClickFrameIndex: function ({frameIndex}) {
      this.isPlaying = false
      this.showSnapshot(frameIndex)
      this.toggleTimebar(true)
    },
    onClickPlay: function () {
      this.isPlaying = true
      this.toggleTimebar(true)
    },
    toggleTimebar: function (isShow) {
      if (isShow) {
        this.isShowTimebar = true
      } else {
        this.isShowTimebar = !this.isShowTimebar
      }
      if (this.isShowTimebar) {
        clearTimeout(this.timebarShow$)
        this.timebarShow$ = setTimeout(() => {
          this.isShowTimebar = false
        }, 3000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.comp-verification-event-snapshot {
  /* common */
  background-color: #fff;
  color: #333;
  font-size: 14px;
  /* outline: 1px solid #fff; */
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}


.comp-verification-event-snapshot .info-container {
  /* common */
  // background-color: #000;
  color: #fff;
  font-size: 0.8em;
  /* size */
  width: 100%;
  /* height: 100%; */
  /* position */
  position: absolute;
  z-index: 1;
  bottom: 0;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  &.timebar {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.3s linear,opacity 0.3s linear;
    &.interactive-timebar{
      visibility: visible;
      opacity: 1;
      // animation: glimpse 2s linear;
      // animation-fill-mode: forwards; /* This is to make it only play once */
    }
  }
}

.comp-verification-event-snapshot .info-container .info-items {
  /* size */
  padding: 0.5em 0.5em 0.5em 0.5em;
  width: calc(100% - 1em);
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.comp-verification-event-snapshot .info-container .info-items .info-item {
  /* common */
  background-color: hsla(202, 100%, 80%, 1);
  color: hsla(193, 100%, 0%, 0.7);
  border-radius: 1px;
  cursor: pointer;
  font-weight: bold;
  white-space: nowrap;
  /* size */
  padding: 2px 0.5em;
  /* position */
  position: relative;
  margin-right: 0.2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.comp-verification-event-snapshot .info-container .info-items .info-item:last-child {
  /* position */
  margin-right: 0;
}
.comp-verification-event-snapshot .info-container .info-items .info-item.black {
  /* common */
  color: #fff;
  background-color: #000;
}
.comp-verification-event-snapshot .info-container .info-items .info-item.info {
  /* common */
  color: #fff;
  background-color: hsla(202, 100%, 50%, 1);
}
.comp-verification-event-snapshot .info-container .info-items .info-item.error {
  /* common */
  color: #fff;
  background-color: hsla(0, 100%, 60%, 1);
}
.comp-verification-event-snapshot .info-container .info-items .info-item.inactive {
  /* common */
  background-color: hsla(202, 0%, 30%, 0.1);
  color: #fff;
}

.comp-verification-event-snapshot .info-container .inner-wrapper {
  /* common */
  background-color: #fff;
  color: #333;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  /* size */
  width: calc(100% - 2em);
  margin: 0.5em;
  padding-left: 0.5em;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  /* border */
  border-left: 0.5em solid #000;
}
.comp-verification-event-snapshot .info-container.info .inner-wrapper {
  /* border */
  border-left: 0.5em solid hsla(202, 100%, 50%, 1);
}
.comp-verification-event-snapshot .info-container.error .inner-wrapper {
  /* border */
  border-left: 0.5em solid hsla(0, 100%, 65%, 1);
}


.comp-verification-event-snapshot .info-container .device-name {
  /* common */
  margin-top: 0.5em;
  /* text */
  white-space: nowrap;
  text-align: left;
  /* size */
  width: calc(100% - 1em);
  padding: 0;
  margin: 0.5em;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.comp-verification-event-snapshot .info-container .device-name.no-name {
  /* common */
  opacity: 0.3;
}


.comp-verification-event-snapshot .info-container .status-container {
  /* common */
  background-color: hsla(202, 0%, 100%, 1);
  color: #fff;
  /* size */
  padding: 0.5em;
  width: 100%;
  height: fit-content;
  /* position */
  position: relative;  
}
.comp-verification-event-snapshot .info-container .status-container .loading-bar {
  /* common */
  background-color: hsla(202, 0%, 10%, 1);
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* animation */
  transition: transform .3s;
  transform-origin: left;
}
.comp-verification-event-snapshot .info-container .status-container .play-bar {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* animation */
  transform-origin: left;
}
.comp-verification-event-snapshot .info-container .status-container.ready {
  /* common */
  background-color: hsla(202, 0%, 20%, 1);
}
.comp-verification-event-snapshot .info-container .status-container.warning {
  /* common */
  background-color: hsla(50, 100%, 50%, 1);
}
.comp-verification-event-snapshot .info-container .status-container.error {
  /* common */
  background-color: hsla(0, 100%, 70%, 1);
}


.comp-verification-event-snapshot .info-container .inner-wrapper .item-container {
  /* common */
  background-color: hsla(202, 0%, 30%, 0.1);
  color: #fff;
  border-radius: 1px;
  cursor: pointer;
  font-weight: bold;
  white-space: nowrap;
  /* size */
  padding: 2px 5px;
  /* position */
  position: relative;
  margin-right: 4px;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.comp-verification-event-snapshot .info-container .inner-wrapper .item-container:last-child {
  /* position */
  margin-right: 0;
}
.comp-verification-event-snapshot .info-container .inner-wrapper .item-container.text {
  /* common */
  color: hsla(193, 100%, 0%, 0.7);
  background-color: transparent;
}
.comp-verification-event-snapshot .info-container .inner-wrapper .item-container.active {
  /* common */
  color: hsla(193, 100%, 0%, 0.7);
  background-color: hsla(202, 100%, 80%, 1);
  /* text */
  text-transform: uppercase;
}
.comp-verification-event-snapshot .info-container .inner-wrapper .item-container.info {
  /* common */
  color: hsla(193, 100%, 100%, 1);
  background-color: hsla(202, 100%, 50%, 1);
  /* text */
  text-transform: uppercase;
}
.comp-verification-event-snapshot .info-container .inner-wrapper .item-container.error {
  /* common */
  color: hsla(193, 100%, 100%, 1);
  background-color: hsla(0, 100%, 65%, 1);
  /* text */
  text-transform: uppercase;
}

.comp-verification-event-snapshot .sensors-location-wrapper {
  /* size */
  width: 100%;
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
}

.comp-verification-event-snapshot .no-snapshot-text-wrapper {
  /* size */
  width: 100%;
  padding-top: calc(100% / 16 * 9);
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
}
.comp-verification-event-snapshot .no-snapshot-text-wrapper .no-snapshot-text {
  /* common */
  font-size: 1em;
  color: #fff;
  background-color: hsla(0, 0%, 20%, 1);
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.comp-verification-event-snapshot .no-snapshot-text-wrapper.has-snapshot {
  /* common */
  opacity: 0.5;
}

.comp-verification-event-snapshot .verification-wrapper-16-9-ratio-wrappper {
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
  /* size */
  width: 100%;
  padding-top: calc(100% / 16 * 9);
}

.comp-verification-event-snapshot .verification-wrapper {
  /* size */
  width: calc(100% - 2em);
  height: calc(100% - 2em);
  margin: 1em;
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
}
.comp-verification-event-snapshot .verification-wrapper.not-scrollable {
  /* mouse */
  pointer-events: none;
}

@keyframes glimpse {
    0% { 
      visibility: visible;
      opacity: 1;
    }
    99% {
      visibility: visible;
      opacity: 1;
    }
    100% {
      visibility: hidden;
      opacity: 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/CompVerificationEventSnapshot.vue